import React, { ReactNode } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from 'reactstrap';

interface CommonModalProps {
  isOpen: boolean;
  toggle: () => void;
  title?: string;
  children?: ReactNode;
  onSave?: () => void;
  showFooter?: boolean;
  saveText?: string;
  cancelText?: string;
  size?: string;
  classes?: string;
}

const CommonModal: React.FC<CommonModalProps> = ({
  isOpen,
  toggle,
  title = '',
  children,
  onSave,
  showFooter = true,
  saveText = 'Save',
  cancelText = 'Cancel',
  size="lg",
  classes = ''
}) => {
  return (
    <div className="modal-dialog" style={{ minWidth: '900px', }}>
      <Modal size={size} isOpen={isOpen} toggle={toggle} className={classes}>

        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>{children}</ModalBody>
        {showFooter && (
          <>

            {onSave && <div className='m-2' style={{ textAlign: 'right' }}><Button color="primary" onClick={onSave}>{saveText}</Button>
            </div>}</>
        )}
      </Modal>
    </div>
  );
};

export default CommonModal;
